<div [hidden]="!menuEnabled">
  <div class="row mt-5 mb-3 hidden" id="divInquiry">
    <div class="col-md-5 container my-auto">
      <div class="row mt-3">
        <div class="col-md-12 text-center">
          <h4 class="text-cust-blue" translate>TrackStatus</h4>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4 text-right" translate>
          <label translate>ID no.</label>/<br />
          <label translate>Regis Tax no.</label>
        </div>
        <div class="col-md-8">
          <input type="text" class="form-control" autocomplete="off" id="IdNo"  [readonly]="disablebtnSave" >
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4 text-right" translate>
          Account no.
        </div>
        <div class="col-md-8">
          <input type="text" class="form-control" autocomplete="off" maxlength="13" id="AccNo" [readonly]="disablebtnSave" >
        </div>
      </div>
      <div class="row mt-3 mb-3">
        <div class="col-md-12 text-center">
          <button class="btn btn-default mr-2" (click)="GetResult()" translate>TrackStatus</button>
          <button class="btn btn-default ml-2" (click)="ClearText()" translate>Cancel</button>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-3 mb-3 hidden" id="divResult">
    <div class="col-12">
      <div class="row">
        <div class="col-12 text-center">
          <h4 class="text-cust-blue" translate>Reimbursement Status</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 mx-auto container container2">
          <div class="row mt-3">
            <div class="col-md-4 text-cust-blue" translate>
              Name<label>:</label>
            </div>
            <div class="col-md-8">
              <input type="text" class="form-control form-control-2" readonly id="txtName">
              <!-- <label id="lblName">ทวีศักดิ์ อุปะละ</label> -->
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-4 text-cust-blue" translate>
              ID no./Tax no.<label>:</label>
            </div>
            <div class="col-md-8">
              <input type="text" class="form-control form-control-2"  readonly id="txtIDNo">
              <!-- <label id="lblIDNo">1234567890987</label> -->
            </div>
          </div>

          <div class="row mt-3 mb-3">
            <div class="col-md-4 text-cust-blue" translate>
              Account no.<label>:</label>
            </div>
            <div class="col-md-8">
              <input type="text" class="form-control form-control-2" maxlength="13" readonly id="txtAccNo">
              <!-- <label id="lblAccNo">1234567890</label> -->
            </div>
          </div>
        </div>
      </div>

      <!-- Progress -->
      <div id="divProgress" class sr-only style="padding-bottom:80px">
        <!-- <div class="row mt-4 text-center">
          <div class="col-md-12">
            <ul id="progressbarimg" class="progressbar-img content-center">
              <li class="active step0"><img src="../../assets/images/status1_active.png"></li>
              <li class="step0"><img src="../../assets/images/status2.png">
              </li>
              <li class="step0">
                <img src="../../assets/images/status1.png">
              </li>
            </ul>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-md-12 text-center">
            <ul id="progressbar" class="progressbar content-center">
              <li class="active step0"><label class="text status-active">จ่ายคืน</label></li>
              <li class="step0"><label class="text status-inactive">ขอตรวจสอบ</label></li>
              <li class="step0"><label class="text status-inactive">อุทธรณ์</label></li>
            </ul>
          </div>
        </div> -->
      </div>
      <!-- End Progress -->

      <!-- New Progress -->
      <div class="row mt-3 mb-3 col-md-8 ">
        <div class="col-sm-2 col-md-3 col-lg-4 col-xl-6">

        </div>
        <div class="col-6 col-md-6">
          
            <ul id="progress">
             <!--  <li><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><p>The First Thing!</p></li>
              <li><div class="divider blue"></div></li>
              <li><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><p>The Second Thing!</p></li>
              <li><div class="divider blue"></div></li>
              <li><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><p>The Third Thing!</p></li>
              <li><div class="divider blue"></div></li>
              <li><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><p>The Fourth Thing!</p></li>
              <li><div class="divider blue"></div></li>
              <li><img width="61" style="background-color: white;" src="../../assets/images/circle_1.png"><p>The Last Thing!</p></li>-->
          </ul>
        </div>
      </div>
      <!-- End New Progress -->

      <div class="col-md-8 mx-auto container container2 sr-only">
        <div class="card-header">
          <div class="row">
            <div class="col-10 my-auto">
              <h3 class="card-title font-cust-blue">ติดตามสถานะ</h3>
            </div>
            <div class="col-2 text-right">
              <button class="btn btn-link" data-toggle="collapse" data-target="#status" aria-expanded="true"
                aria-controls="status">
                <span class="fa fa-lg fa-chevron-circle-up"></span>
              </button>
            </div>
          </div>
        </div>
        <div class="card-body p-0 collapse show" id="status">
          <table id="tbStatus"  class="table table-bordered table-hover result-table">
            <thead>
              <tr>
                <th>เลขที่คำขอ</th>
                <th>ประเภทการติดตามสถานะ</th>
                <th>สถานะ</th>
                 <!--<th>ประเภทคำขอ (มุมมองระบบ)</th>
               <th>สถานะ DROS (มุมมองระบบ)</th> -->
                <th>วันที่ปรับปรุงสถานะ</th>
              </tr>
            </thead>
            <tbody>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row mt-3 mb-3">
        <div class="col-md-8 container">
          <div class="row mt-3">
            <div class="col-md-12">
              <h5 class="text-cust-blue" translate>Status</h5>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-md-12">
              <label id="lblInquiryResult1" class="status-active-footer" translate>สถาบันคุ้มครองเงินฝาก (สคฝ.)
                ได้ทำการจ่ายเงินคืนให้ลูกค้าเรียบร้อยแล้ว</label>
            </div>
          </div>
          <div class="row mt-1 mb-3">
            <div class="col-md-12">
              <label id="lblInquiryResult2" class="status-active-footer" translate>เมื่อวันที่ 01/01/2563</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-3 mb-3">
        <div class="col-12 text-center">
          <button class="btn btn-default mr-2" (click)="Back()" translate>Home</button>
        </div>
      </div>

      
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/status-tracking/status-tracking.component.html